import React, { Component } from 'react';
import './Footer.scss';

const Footer = React.forwardRef((props, ref) => {
  return (
    <div className="footer" ref={ref}>
      <div className="footer-container white-text">
        <div className="container-icons">
          <a href="https://www.facebook.com/oracliom/" target="_blank" rel="noopener noreferrer" className="container-icon-footer"><img alt="fb_logo" src="/media/icons/fb_logo.png" className="icon-footer" /></a>
          <a href="https://www.linkedin.com/company/oracliomtechnologies" target="_blank" rel="noopener noreferrer" className="container-icon-footer"><img alt="ln_logo" src="/media/icons/ln_logo.png" className="icon-footer" /></a>
          <a href="https://www.instagram.com/oracliom/" target="_blank" rel="noopener noreferrer" className="container-icon-footer"><img alt="ig_logo" src="/media/icons/ig_logo.png" className="icon-footer" /></a>
          <a href="https://api.whatsapp.com/send?phone=+48537435130" target="_blank" rel="noopener noreferrer" className="container-icon-footer"><img alt="wa_logo" src="/media/icons/wa_logo.png" className="icon-footer" /></a>
          <a href="tel:+48537435130" target="_blank" rel="noopener noreferrer" className="container-icon-footer"><img alt="phone_logo" src="/media/icons/phone_logo.png" className="icon-footer" /></a>
        </div>
        <h1>Oracliom</h1>
        <h4>Transform your Digital Idea into a Real Business during this Pandemic</h4>
        <a className="link-white poiret-font" href="mailto:hello@oracliom.com"><p> hello@oracliom.com</p></a>
        <a className="link-white poiret-font" href="tel:+48537435130"><p> +48 537 435 130</p></a>
        <p className="poiret-font"><i className="material-icons vertical-align">location_on</i> Korfantego 30/19 - Katowice</p>
        <p className="poiret-font">© 2021 Copyright Oracliom</p>
      </div>
    </div>
  );
});

export default Footer;
